export interface QueryDomainResponse {
  message: string;
  success: any;
  status: string;
  description: string;
  authPattern?: string;
}

const hostname = window.location.hostname;

export async function queryDomain(userEmail: string): Promise<QueryDomainResponse> {
  let baseurl = '';
  
  if (hostname.includes('localhost')) {
    baseurl = 'http://localhost:8080';
  } else if (hostname.includes('dev')) {
    baseurl = 'https://candidateinterviewscheduler-dev.pwc.com';
  } else if (hostname.includes('stg') || hostname.includes('stage')) {
    baseurl = 'https://candidateinterviewscheduler-stg.pwc.com';
  } else {
    baseurl = 'https://candidateinterviewscheduler.pwc.com';
  }

  // Extract domain from email
    const emailParts = userEmail.split('@');
    if (emailParts.length !== 2 || !emailParts[1]) {
      throw new Error('Invalid email format');
    }
    const domain = emailParts[1];
    
    console.log(`Extracted domain: ${domain} from email: ${userEmail}`);

  const res = await fetch(`${baseurl}/api/candidate-dashboard/query-domain`, {
    method: 'POST',
    headers: { 
      'Accept': 'application/json', 
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ userEmail, domain }),
  });

  if (!res.ok) throw new Error(`Query domain failed: ${res.status} ${res.statusText}`);
  return res.json();
}